import React from 'react';
import { Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { QBox, QFormControl, QSelect, QSelectItem, QSelectPlaceholder, QText } from '@qualio/ui-components';

type TemplateStatusFilterProps = {
  statusOptions: QSelectItem[];
};

export const TemplateStatusFilter: React.FC<TemplateStatusFilterProps> = ({ statusOptions }) => {
  const { t } = useTranslation();

  return (
    <QFormControl label={t('template.list.filters.status.label')}>
      <Controller
        name="status"
        render={({ field: { onChange, value, ...field } }) => (
          <QBox data-cy="template-status-filter-v2">
            <QSelect
              {...field}
              options={statusOptions}
              value={value ?? null}
              onChange={(item) => onChange(item?.value ?? null)}
              isClearable={true}
              clearInputOnSelect={value == null}
              aria-label={t('template.list.filters.status.ariaLabel')}
            >
              <QSelectPlaceholder>
                <QText>{t('template.list.filters.status.placeholder')}</QText>
              </QSelectPlaceholder>
            </QSelect>
          </QBox>
        )}
      />
    </QFormControl>
  );
};
